import { createMiddleware } from 'hono/factory'
import { ForbiddenError as CASLForbiddenError } from '@casl/ability'
import { ForbiddenError, UnauthorizedError } from '../../core/errors/app-error.js'
import type { Actions, Subjects } from '@kernel/abilities/ability.types.js'
import type { NexusEnv } from '../types.js'

/**
 * Hono middleware that requires authentication AND a CASL ability grant.
 * - No ability → 401 Unauthorized
 * - Ability but cannot perform action → 403 Forbidden
 */
export function requireAbility(action: Actions, subject: Subjects) {
  return createMiddleware<NexusEnv>(async (c, next) => {
    const ability = c.get('ability')
    if (!ability) throw new UnauthorizedError('Authentication required')
    try {
      CASLForbiddenError.from(ability).throwUnlessCan(action, subject)
    } catch {
      throw new ForbiddenError(
        `Not allowed to ${action} ${typeof subject === 'string' ? subject : 'this resource'}`
      )
    }
    await next()
  })
}
